import { NgModule, ApplicationRef, ErrorHandler, forwardRef, ElementRef, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayModule } from '@angular/cdk/overlay';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
//import { IndicatorsModule } from "@progress/kendo-angular-indicators";
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { GridModule, ExcelModule, PDFModule, ExcelService } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { MenuModule } from '@progress/kendo-angular-menu';
import { POPUP_CONTAINER, PopupModule } from '@progress/kendo-angular-popup';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { ToolBarModule, ToolBarToolComponent } from '@progress/kendo-angular-toolbar';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
//import { AdalService } from 'ng2-adal/dist/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//import { LoggedInGuard } from "./authentication/logged-in.guard";
import { ChangelogComponent } from './changelog/changelog.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { FlowEnvironmentComponent } from './flow-environment/flow-environment.component';
import { FlowRunsComponent } from './flow-runs/flow-runs.component';
import { FlowTagsComponent } from './flow-tags/flow-tags.component';
import { FlowDetailComponent } from './flows/flow.detail.component';
import { FlowsComponent } from './flows/flows.component';
import { GridContextMenuComponent } from './grid-context-menu.component';
import { OAuthHandshakeModule } from './oauth-callback/oauth-callback.module';
import { FlowManagementService } from './services/flow-management.service';
//import { SecretService } from './services/secret.service';
import { FluentUIService } from './services/fluent-ui.service';
import { WelcomeComponent } from './welcome/welcome.component';
import { FlowActionsComponent } from './flow-actions/flow-actions.component';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { ApprovalsComponent } from './approvals/approvals.component';
import { DiagramsComponent } from './diagrams/diagrams.component';
// import { ConnectorsComponent } from './connectors/connectors.component';
import { FlowRenameComponent } from './flows/flow-rename.component';
import { RouteRootComponent } from './route-root/route-root.component';
import { AvatarModule, LayoutModule } from '@progress/kendo-angular-layout';
import { SortableModule } from '@progress/kendo-angular-sortable';
import { ConnectionsComponent } from './connections/connections.component';
import { ConnectionEditComponent } from './connections/connection-edit.component';
import { ConnectorEditComponent } from './connections/connector-edit.component';
//import { AnalyticsService } from './services/analytics.service';
import { FlowOwnersComponent } from './flow-owners/flow-owners.component';
//import { CustomErrorHandler } from './custom.error.handler';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
//import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee, faUserCheck, faUserCircle, faExternalLinkAlt, faHandHoldingHeart, faHandHoldingUsd, faHeart, faBoxOpen, faMagic, faFolderOpen, faBatteryEmpty, faBatteryHalf, faBatteryFull, faAtom, faChargingStation, faBolt, faCreditCard, faTable, faSortAlphaUp, faFilter, faHashtag, faBars, faExclamationCircle, faChartBar, faClipboard, faEdit, faSearch, faFileDownload, faProjectDiagram, faArchive, faStopwatch, faUserCog, faUserPlus, faFileImport, faStream, faDesktop, faServer, faHistory, faEnvelopeOpenText, faDatabase, faLightbulb, faAddressCard, faQuestionCircle, faArrowCircleRight, faUserGraduate, faPlug, faCheck, faChartLine, faMagnifyingGlassChart, faSpinner } from '@fortawesome/free-solid-svg-icons';
//import { FlowAdminsComponent } from './flow-admins/flow-admins.component';
import { MonacoEditorModule, NgxMonacoEditorConfig } from 'ngx-monaco-editor-v2';
import { SubscriptionPaymentComponent } from './subscription-payment/subscription-payment.component';
import { TabContentLoadOnDemandDirective } from './route-root/loadOnDemand.directive';
import { ToolBarSubscriptionComponent } from './flow-runs/flow-runs-sub.component';
import { MultiSelectModule, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { SubscriptionGuard } from './services/payment.service';
// import { MsalModule } from "@azure/msal-angular";
// import { MsalInterceptor } from "@azure/msal-angular";
// import { LogLevel } from 'msal';

import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FlowVersionsComponent } from './flow-versions/flow-versions.component';
import { SettingsComponent } from './settings/settings.component';
import { FlowDiffComponent } from './flow-diff/flow-diff.component';
import { FlowSearchComponent } from './flow-search/flow-search.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DeployComponent } from './deploy/deploy.component';
import { MsalFlowInterceptor } from './services/MsalFlowInterceptor';
import { SparklineModule, ChartsModule } from '@progress/kendo-angular-charts';
import 'hammerjs';
import { DebugComponent } from './debug/debug.component';
import { DebugMakersComponent } from './debug/debug-makers.component';
import { DebugStoreComponent } from './debug/debug-store.component';
//import { MsalComponent } from './msal/msal.component';
import { SuccessComponent } from './success/success.component';
import { SuccessLineComponent } from './success-line/success-line.component';
import { SolutionsComponent } from './solutions/solutions.component';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { FlowSolutionComponent } from './flow-solution/flow-solution.component';
import { PlanEditComponent } from './plan-edit/plan-edit.component';
import { PromotionComponent } from './promotion/promotion.component';
import { ClipboardComponent } from './clipboard/clipboard.component';
import { ClipboardModule } from './clipboard/clipboard-copy.directive';
import { AboutComponent } from './welcome/about.component';
import { FlowsByActionsComponent } from './flows/flows-by-actions.component';
//import { RouterModule } from '@angular/router';
import { TranslateComponent } from './translate/translate.component';
import { PowerAppsComponent } from './powerapps/powerapps.component';
import { ApplicationInsightsService } from './services/application-insights.service';
import { CustomErrorHandler } from './custom.error.handler';
import { FlowDiagramComponent } from './flow-diagram/flow-diagram.component';
import { SubscriptionButtonComponent } from './subscription-payment/subscription-button.component';
import { PricingComponent } from './welcome/pricing.component';
//import { Circle } from '@progress/kendo-drawing/dist/npm/geometry';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
//import { GridSearchToolComponent } from './flows/grid-search-tool.component';
import { GanttComponent } from './flow-runs/gantt.component';
import { HttpCancelInterceptor, HttpCancelService } from './services/http-cancel.service';
import { ZipComponent } from './zip/zip.component';
import { BadgeModule, LoaderModule } from '@progress/kendo-angular-indicators';
import { DatePipe, JsonPipe } from '@angular/common';
import { LabelModule } from '@progress/kendo-angular-label';
import { RippleModule } from '@progress/kendo-angular-ripple';
import { FailedComponent } from './msal/failed.component';
import { LoginComponent } from './msal/login.component';
import { MultiCheckFilterComponent } from './flows/multicheck-filter.component';
import { FlowEditorComponent } from './flows/flow.editor.component';
import { FlowViewComponent } from './flows/flow-view.component';
import { ApiService } from './services/api.service';
import { DetailsComponent } from './teams/details.component';
import { ScheduleComponent } from './teams/schedule.component';
import { DateInputModule, TimePickerModule } from '@progress/kendo-angular-dateinputs';
import { IconsModule, IconSettingsService, ICON_SETTINGS } from '@progress/kendo-angular-icons'
import { IconService } from './services/icon.service';
import { DataverseMsalInterceptor } from './msal/msal.interceptor';
import { UserLicenseComponent } from './settings/user-license.component';
import { AboutFsFreeComponent } from './welcome/about-fs-free.component';
import { AboutFsProComponent } from './welcome/about-fs-pro.component';
import { AboutFsTeamsComponent } from './welcome/about-fs-teams.component';
import { SetupComponent } from './settings/setup.component';
import { ServicesComponent } from './offerings/services.component';
import { McpAnnounceComponent } from './mcp/mcp-announce.component';
import { WebinarPromoComponent } from './mcp/webinar-promo.component';
import { WhatsNewComponent } from './whats-new/whats-new.component';
import { PermissionComponent } from './teams/permission.component';
import { TeamsFlowsComponent } from './teams/teams.flows.component';
import { SharedModule } from './shared.module';
import { TeamsModule } from './teams/teams.module';
import { FlowsRequestComponent } from "./flows/flows.request.component";
import { FlowsChildFlowsComponent } from "./flows/flows.child-flows.component";
import { ChildFlowsReplaceConnectionComponent } from "./flows/flows.child-flows-replace-connection.component";
import { ContactEmailSectionComponent } from './settings/contact-email-section.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
//import { StorageService } from './services/storage.service';

// import { MonacoEditorModule } from 'ngx-monaco';
// import * as workflowdefinition from './workflowdefinition.json';

// const monacoConfig: NgxMonacoEditorConfig = {
//     onMonacoLoad: () => {
//         const id = "workflowdefinition.json";
//         monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
//             validate: true,
//             schemas: [{
//                 uri: "https://schema.management.azure.com/providers/Microsoft.Logic/schemas/2016-06-01/workflowdefinition.json#",
//                 fileMatch: [id],
//                 schema: workflowdefinition
//             }]
//         });
//     }
// };

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1; // Remove this line to use Angular Universal

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

// export const protectedResourceMap: [string, string[]][] = [
//     //['https://buildtodoservice.azurewebsites.net/api/todolist', ['api://a88bb933-319c-41b5-9f04-eff36d985612/access_as_user']],

//     //['https://flowstudio.app/api', ['api://78c5bd67-31ba-4061-a311-13f2212530d3/user_impersonation']],
//     ['https://graph.microsoft.com/v1.0/me', ['user.read']],
//     // ['https://management.azure.com/', [
//     //     'https://management.azure.com//user_impersonation'
//     // ]],
//     ['https://service.flow.microsoft.com/', [
//         // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Flows.Read.All',
//         // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Flows.Manage.All',
//         // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Activity.Read.All',
//         // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Approvals.Read.All',
//         // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Approvals.Manage.All'
//         'https://service.flow.microsoft.com//Flows.Read.All',
//         'https://service.flow.microsoft.com//Flows.Manage.All',
//         'https://service.flow.microsoft.com//Activity.Read.All',
//         'https://service.flow.microsoft.com//Approvals.Read.All',
//         'https://service.flow.microsoft.com//Approvals.Manage.All'
//     ]],
//     ['https://service.powerapps.com/', [
//         //'api://475226c6-020e-4fb2-8a90-7a972cbfc1d4/User',
//         'https://service.powerapps.com/User'
//     ]],
//     [
//         'https://services.crm.dynamics.com', [
//             "https://services.crm.dynamics.com/user_impersonation"
//             //"https://org9ef703f1.api.crm6.dynamics.com/user_impersonation"
//             //'api://82f77645-8a66-4745-bcdf-9706824f9ad0/user_impersonation'
//         ]
//     ],
//     // [
//     //     'https://api.flow.microsoft.com/', [
//     //         'https://management.azure.com//user_impersonation'
//     //     ]
//     // ],
//     // ['https://api.powerapps.com', []],
//     // ['https://graph.microsoft.com/', []],
// ];

export function MSALInstanceFactory(): IPublicClientApplication {



            //tenant: 'common',
            //extraQueryParameter: 'nux=1', //&prompt=consent',
            //clientId: '7f4aaf40-bd90-4647-ae9d-d31472f32c86',
            // authority: "https://login.microsoftonline.com/common/",
//            validateAuthority: true,
            //redirectUri: `${locationOrigin}/token`,
            // cacheLocation: 'localStorage',
            //postLogoutRedirectUri: `${locationOrigin}}/welcome`,
//            navigateToLoginRequestUrl: false,
            //popUp: false,
            //consentScopes: [],
            // consentScopes: ["user.read", "offline_access"],
            // unprotectedResources: [
            //     "https://flowstudio.app/",
            //     "https://flow-studio-dev.azurewebsites.net/",
            //     "https://flow-studio.azurewebsites.net/",
            //     "https://dev.flowstudio.app/",
            //     "https://powerstudio.app/",
            // ],
            // protectedResourceMap: protectedResourceMap,
            // logger: loggerCallback,
            // correlationId: "1000",
            // //level: LogLevel.Info,
            // piiLoggingEnabled: true


  const msalInstance = new PublicClientApplication({
    auth: {
      clientId: '91723a5f-ef28-4393-aa4f-7bbc3379f131',
      // clientId: '3fba556e-5d4a-48e3-8e1a-fd57c12cb82e', // PPE testing environment
      authority: "https://login.microsoftonline.com/common",
      // authority: 'https://login.windows-ppe.net/common', // PPE testing environment
      postLogoutRedirectUri: '/',
      navigateToLoginRequestUrl: false,
    },
    cache: {      
      cacheLocation: BrowserCacheLocation.LocalStorage,
      temporaryCacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      // Give silent iframe auth enough time on slower corporate networks.
      iframeHashTimeout: 15000,
      loadFrameTimeout: 15000,
      windowHashTimeout: 15000,
      loggerOptions: {
        loggerCallback,
        correlationId: "1000",
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false
      }
    }
  });
  return msalInstance;
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
   let protectedResourceMap = new Map<string, Array<string>>();
//   protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  // protectedResourceMap.set('https://graph.microsoft-ppe.com/v1.0/me', ['user.read']); // PPE testing environment
  protectedResourceMap.set('https://graph.microsoft.com/v1.0', ['user.read']);
  protectedResourceMap.set('https://graph.microsoft.com/beta', ['user.read']);
    // ['https://management.azure.com/', [
    //     'https://management.azure.com//user_impersonation'
    // ]],
  protectedResourceMap.set('https://*.flow.microsoft.com/*/scopes/admin/', [
    'https://service.powerapps.com/User',
  ]);
  protectedResourceMap.set('https://*.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/', [
      // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Flows.Read.All',
      // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Flows.Manage.All',
      // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Activity.Read.All',
      // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Approvals.Read.All',
      // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Approvals.Manage.All'
      // 'https://service.flow.microsoft.com//Flows.Read.All',
      'https://service.flow.microsoft.com//Flows.Manage.All',
      'https://service.flow.microsoft.com//Activity.Read.All',
      // 'https://service.flow.microsoft.com//Approvals.Read.All',
      'https://service.flow.microsoft.com//Approvals.Manage.All',
      // 'https://service.flow.microsoft.com//User',
  ]);
  protectedResourceMap.set('https://*.api.powerplatform.com/powerautomate/', [
    // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Flows.Read.All',
    // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Flows.Manage.All',
    // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Activity.Read.All',
    // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Approvals.Read.All',
    // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Approvals.Manage.All'
    // 'https://service.flow.microsoft.com//Flows.Read.All',
    'https://service.flow.microsoft.com//Flows.Manage.All',
    'https://service.flow.microsoft.com//Activity.Read.All',
    // 'https://service.flow.microsoft.com//Approvals.Read.All',
    'https://service.flow.microsoft.com//Approvals.Manage.All',
    // 'https://service.flow.microsoft.com//User',
]);


    // protectedResourceMap.set('https://api.flow.microsoft.com/', [
    //     // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Flows.Read.All',
    //     // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Flows.Manage.All',
    //     // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Activity.Read.All',
    //     // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Approvals.Read.All',
    //     // 'api://7df0a125-d3be-4c96-aa54-591f83ff541c/Approvals.Manage.All'
    //     'https://service.flow.microsoft.com//Flows.Read.All',
    //     'https://service.flow.microsoft.com//Flows.Manage.All',
    //     'https://service.flow.microsoft.com//Activity.Read.All',
    //     'https://service.flow.microsoft.com//Approvals.Read.All',
    //     'https://service.flow.microsoft.com//Approvals.Manage.All'
    // ]);
    protectedResourceMap.set('https://*.powerapps.com/', [
        'https://service.powerapps.com/User'
    ]);
    // protectedResourceMap.set('https://api.powerapps.com/', [
    //     'https://service.powerapps.com/User'
    // ]);
    protectedResourceMap.set('https://services.crm.dynamics.com', [
            "https://services.crm.dynamics.com/user_impersonation"
            //"https://org9ef703f1.api.crm6.dynamics.com/user_impersonation"
            //'api://82f77645-8a66-4745-bcdf-9706824f9ad0/user_impersonation'
    ]);
    // protectedResourceMap.set('https://*.api.*.dynamics.com', [
    //         "https://services.crm.dynamics.com/user_impersonation"
    //         //"https://org9ef703f1.api.crm6.dynamics.com/user_impersonation"
    //         //'api://82f77645-8a66-4745-bcdf-9706824f9ad0/user_impersonation'
    // ]);
    protectedResourceMap.set('http://localhost:4280/graphql', ['user.read']);
    protectedResourceMap.set('http://localhost:4248/graphql', ['user.read']);
    protectedResourceMap.set('https://localhost:7073/graphql', ['user.read']);
    protectedResourceMap.set('https://flowstudio.app/graphql', ['user.read']);
    protectedResourceMap.set('https://dev.flowstudio.app/graphql', ['user.read']);
    protectedResourceMap.set('https://prod.flowstudio.app/graphql', ['user.read']);

    protectedResourceMap.set('https://graph.microsoft.com/v1.0', ['user.read']);

    protectedResourceMap.set('http://localhost:4200/', null);
    protectedResourceMap.set('http://localhost:4280/', null);
    protectedResourceMap.set('http://localhost:4248/', null);
    protectedResourceMap.set('https://flowstudio.app/', null);
    protectedResourceMap.set('https://dev.flowstudio.app/', null);
    protectedResourceMap.set('https://prod.flowstudio.app/', null);
    protectedResourceMap.set('https://flow-studio-dev.azurewebsites.net/', null);
    protectedResourceMap.set('https://flow-studio.azurewebsites.net/', null);
    protectedResourceMap.set('https://powerstudio.app/', null);


  return {
    interactionType: InteractionType.Redirect,        
    authRequest: (msalService, req, originalAuthRequest)=> {

        return {
          ...originalAuthRequest,
          redirectUri: `${window.location.origin}/token`,
          loginFailedRoute: '/login-failed',
        }
    },
    protectedResourceMap
  };
}

export function registerFontAwesomeIconsFactory(library: FaIconLibrary): () => void {
  return () => {
    library.addIcons(
      faCoffee, faUserCheck, faUserCircle, faExternalLinkAlt, faHandHoldingHeart, faHandHoldingUsd, faHeart, faBoxOpen, faMagic, faFolderOpen,
      faBatteryEmpty, faBatteryHalf, faBatteryFull, faAtom, faChargingStation, faBolt, faCreditCard,
      faTable, faSortAlphaUp, faFilter, faHashtag, faBars, faExclamationCircle, faChartBar, faClipboard,
      faEdit, faUserCog, faUserPlus, faSearch, faFileImport, faStream, faFileDownload, faProjectDiagram, faArchive, faStopwatch,
      faDesktop, faServer, faHistory, faEnvelopeOpenText, faDatabase, faLightbulb,
      faAddressCard, faPlug,
      faQuestionCircle, faArrowCircleRight,
      faUserGraduate,
      faCheck, faChartLine, faMagnifyingGlassChart, faSpinner
    );
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: (msalService, state)=> {
      return {
        scopes: [
          "user.read", "offline_access"        
        ],
        redirectUri: `${window.location.origin}/token`,
      }
    },
    loginFailedRoute: '/login-failed'
  };
}
//var window:any = window;

@NgModule({
    declarations: [
        AppComponent,
        FlowsComponent,
        FlowDetailComponent,
        FlowRunsComponent,
        GridContextMenuComponent,
        WelcomeComponent,
        FlowEnvironmentComponent,
        ChangelogComponent,
        FeedbackComponent,
        FlowTagsComponent,
        FlowActionsComponent,
        ApprovalsComponent,
        DiagramsComponent,
        // ConnectorsComponent,
        FlowRenameComponent,
        RouteRootComponent,
        ConnectionsComponent,
        FlowOwnersComponent,
        // FlowAdminsComponent,
        SubscriptionPaymentComponent,
        ServicesComponent,
        McpAnnounceComponent,
        WebinarPromoComponent,
        WhatsNewComponent,
        TabContentLoadOnDemandDirective,
        ToolBarSubscriptionComponent,
        FlowVersionsComponent,
        SettingsComponent,
        SetupComponent,
        UserLicenseComponent,
        FlowDiffComponent,
        FlowSearchComponent,
        PrivacyComponent,
        DashboardComponent,
        DeployComponent,
        DebugComponent,
        DebugMakersComponent,
        DebugStoreComponent,
        //MsalComponent,
        SuccessComponent,
        SuccessLineComponent,
        SolutionsComponent,
        FlowSolutionComponent,
        PlanEditComponent,
        PromotionComponent,
        ClipboardComponent,
        AboutComponent,
        AboutFsFreeComponent,
        AboutFsProComponent,
        AboutFsTeamsComponent,
        FailedComponent,
        LoginComponent,
        FlowsByActionsComponent,
        TranslateComponent,
        PowerAppsComponent,
        FlowDiagramComponent,
        SubscriptionButtonComponent,
        PricingComponent,
        // GridSearchToolComponent,
        GanttComponent,
        ZipComponent,
        MultiCheckFilterComponent,
        FlowEditorComponent,
        FlowViewComponent,
        FlowsRequestComponent,
        FlowsChildFlowsComponent,
        ChildFlowsReplaceConnectionComponent,
        ContactEmailSectionComponent,
        VerifyEmailComponent,
        ConnectionEditComponent,
        ConnectorEditComponent
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        // RouterModule,
        FormsModule,
        HttpClientModule,

        GridModule,
        ExcelModule,
        MenuModule,
        PopupModule,
        RippleModule,
        OAuthHandshakeModule,
        // NgJsonEditorModule,
        DialogsModule,
        LabelModule,
        InputsModule,
        IconsModule,
        DateInputModule,
        ButtonsModule,
        ScrollViewModule,
        TooltipModule,
        TreeViewModule,
        ListViewModule,
        AvatarModule,
        LayoutModule,
        MultiSelectModule,
        BadgeModule,
        LoaderModule,
        TimePickerModule,
        FontAwesomeModule,
        MonacoEditorModule.forRoot( /*monacoConfig*/),
        NotificationModule,
        MsalModule,
        SparklineModule,
        ChartsModule,
        DropDownsModule,
        SortableModule,
        PDFModule,
        PDFExportModule,
        ClipboardModule,
        OverlayModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: false }),
        SharedModule,
        TeamsModule
    ],
    providers: [
        //        AdalService,
        //        SecretService,
        FlowManagementService,
        FluentUIService,
        //LoggedInGuard,
        SubscriptionGuard,
        // StorageService,
        //AnalyticsService,
        ApplicationInsightsService,
        ApiService,
        ExcelService,
        HttpCancelService,
        // {provide: HTTP_INTERCEPTORS, useClass: MsalFlowInterceptor, multi: true},
        { provide: HTTP_INTERCEPTORS, useClass: HttpCancelInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: DataverseMsalInterceptor, multi: true },
        { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
        { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
        { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
        // {provide: POPUP_CONTAINER, useFactory: ()=>{
        //   return { nativeElement: document.body } as ElementRef
        // }},
        //{provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true},
        { provide: ErrorHandler, useClass: CustomErrorHandler },
        // {provide: ToolBarToolComponent, useExisting: forwardRef(() => SubscriptionButtonComponent)}
        DatePipe,
        JsonPipe,
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        // IconSettingsService
        { provide: IconSettingsService, useClass: IconService },
        { provide: ICON_SETTINGS, useValue: { type: "font" } },
        { provide: APP_INITIALIZER, useFactory: registerFontAwesomeIconsFactory, deps: [FaIconLibrary], multi: true },
        { provide: APP_INITIALIZER, useFactory: (msalService: MsalService) => async () => { await msalService.instance.initialize(); }, deps: [MsalService], multi: true }
    ],
    bootstrap: [
      AppComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {

    // ngDoBootstrap(ref: ApplicationRef) {
    //     if (window !== window.parent && !window.opener && window.frameElement.id.startsWith("msal")) {
    //         console.log("Bootstrap: MSAL");
    //         ref.bootstrap(MsalRedirectComponent);
    //     }
    //     else {
    //         //this.router.resetConfig(RouterModule);
    //         //console.log("Bootstrap: App");
    //         ref.bootstrap(AppComponent);
    //     }
    // }


}


